import {Button, Text} from 'grommet'
import styled from 'styled-components'
import { languageConfig } from '../../../translations/config'
import { useTranslation } from "../TranslationContext"

const LanguageList = styled.ul`
  display: flex;
  margin: 0;
  padding: 0;
  list-style: none;
`

const LanguageListItem = styled.li`
  &::after {
    display: inline-block;
    content: '|';
    margin: 0 0.5em;
    font-size: 0.8em;
    opacity: 0.8;
    vertical-align: top;
  }

  &:last-child::after {
    display: none;
  }
`

export default function LanguageSwitcher() {
  const {selectedLanguage, switchLanguage} = useTranslation()

  return (
    <Text>
      <LanguageList>
      {languageConfig.map((language) => {

        return (
          <LanguageListItem key={language.label}>
            <Button
              plain
              label={language.label}
              onClick={() => switchLanguage(language.localeCode)}
              disabled={language.localeCode === selectedLanguage}
            />
          </LanguageListItem>
        )
      })}
      </LanguageList>
    </Text>
  )
}
